<template>
  <div class="workbench-component-orders-wait-container default-table">
    <el-form :inline="true" :model="formSearch" size="mini">
      <el-form-item label="客户名称" class="form-item-customer">
        <el-input v-model="formSearch.customer_name" placeholder="客户名称" clearable/>
      </el-form-item>
      <el-form-item label="订单号">
        <el-select
            v-model="formSearch.order_nos" placeholder="请选择订单号"
            multiple filterable allow-create default-first-option clearable
        />
        <el-option v-for="item in []" :key="item.value" :value="item.value"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getTableData">查询</el-button>
      </el-form-item>
      <el-form-item style="float: right;margin-right: 0;">
        <el-button v-if="userAuth.can_todo_sign_covenants" type="primary" @click="handelBatchSign">批量签约</el-button>
      </el-form-item>
    </el-form>
    <el-table ref="table" :data="tableData" border height="calc(100% - 88px)">
      <el-table-column type="selection" width="55"/>
      <el-table-column v-if="userAuth.can_todo_sign_covenants" label="操作" align="center" min-width="80">
        <template slot-scope="{row}">
          <el-button type="text" size="mini" style="padding: 0;" @click="handelSign(row)">签约</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="order_no" label="订单编号" align="center" min-width="80"/>
      <el-table-column prop="customer_name" label="客户名称" align="center" min-width="120" show-overflow-tooltip/>
      <el-table-column prop="artist_name" label="红人名称" align="center" min-width="120" show-overflow-tooltip/>
      <el-table-column prop="brand" label="品牌" align="center" min-width="120" show-overflow-tooltip/>
      <el-table-column prop="product" label="产品/内容" align="center" min-width="120" show-overflow-tooltip/>
      <el-table-column prop="payment_account" label="含税收入" align="center" min-width="120" show-overflow-tooltip/>
      <el-table-column prop="sale" label="销售" align="center" min-width="120" show-overflow-tooltip/>
      <el-table-column prop="exec_timestamp" label="执行时间" align="center" min-width="120"/>
      <el-table-column prop="created_timestamp" label="下单时间" align="center" min-width="120"/>
    </el-table>
    <el-pagination
        background
        :current-page="formSearch.page"
        :page-size="formSearch.page_size"
        layout="total, prev, pager, next"
        :total="formSearch.total"
        @current-change="handleCurrentChange"
        style="margin-top: 10px;float: right;"
    />

    <el-dialog title="签约" :visible.sync="dialogStore" width="680px" center>
      <el-input v-model="formStore.customer_name" disabled/>
      <el-select v-model="formStore.covenant_id" placeholder="请选择合同" filterable default-first-option remote
                 style="width:100%;margin: 14px 0;" :remote-method="handelRemote" clearable>
        <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.covenant_title"
            :value="item.id">
          <span style="color: #8492a6; font-size: 13px">「{{ item.covenant_no }}」</span>
          <span>{{ item.covenant_title }}</span>
        </el-option>
        <el-option disabled value="">
          <span style="color: #8492a6; font-size: 12px">输入系统编号/合同标题关键词检索选择</span>
        </el-option>
      </el-select>
      <div style="height: 180px;border: 1px dashed #d9d9d9;">
        <el-table v-if="$refs.table" :data="$refs.table.selection" height="100%">
          <el-table-column :label="`共选择${$refs.table.selection.length}条，订单编号如下请仔细核对`" align="center"
                           width="180">
            <template slot-scope="{row,$index}">
              {{ $index + 1 }}. {{ row.created_timestamp }}
              <span v-for="field in ['sale','artist_name', 'payment_account', 'order_no']" :key="$index + field">
                <template v-if="row[field]">&nbsp;/&nbsp;{{ row[field] }}&emsp14;&emsp14;</template>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogStore = false">取 消</el-button>
          <el-button type="primary" @click="handelStoreSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {queryOrdersTiniList} from "@/api/adOrder";
import {orderCovenantOptions, orderCovenantDoSign} from "@/api/orderCovenant";

const ModelFormStore = {
  covenant_id: null,
  customer_id: null,
  customer_name: null,
  id: null,
}
const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).value : {id: -1}
const creator_id = user.id

export default {
  name: "WorkbenchComponentOrders",
  inject: ["refreshSummation"],
  data() {
    return {
      dialogStore: false,
      options: [],
      tableData: [],
      formSearch: {
        page: 1,
        page_size: 20,
        total: 0,
        bool_covenant: 0,
        order_nos: [],
        customer_name: null,
      },
      formStore: {...{}, ...ModelFormStore},
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  mounted() {
    this.getTableData()
  },
  methods: {
    callbackSuccess() {
      this.refreshSummation();
      this.getTableData();
    },
    handelSign(row) {
      this.$refs.table.clearSelection();
      this.$refs.table.toggleRowSelection(row);
      this.handelBatchSign()
    },
    handelBatchSign() {
      const {selection} = this.$refs.table
      let customer_ids = selection.map(_ => {
        return _.customer_id
      })
      customer_ids = [...new Set(customer_ids)]
      if (!customer_ids.length) {
        this.$message.warning('请最少选择一条数据！')
        return false;
      }
      if (customer_ids.length > 1) {
        this.$message.warning('请选择相同的客户进行批量签约！')
        return false;
      }
      this.formStore = {...{}, ...ModelFormStore};
      this.formStore.customer_id = selection[0].customer_id
      this.formStore.customer_name = selection[0].customer_name
      this.handelRemote()
      this.dialogStore = true;
    },
    handleCurrentChange(val) {
      this.formSearch.page = val
      this.getTableData()
    },
    async getTableData() {
      const response = await queryOrdersTiniList(this.formSearch)
      this.tableData = response.model.data || [];
      this.formSearch.total = response.model.total || 0;

    },
    async handelRemote(query) {
      const {customer_id} = this.formStore
      if (!customer_id) {
        return false;
      }
      const response = await orderCovenantOptions({creator_id, customer_id, value: query})
      this.options = response.data || []
    },
    async handelStoreSure() {
      if (!this.formStore.covenant_id) {
        this.showToast({h: this, icon: "el-icon-error", text: '请选择合同', duration: 2000});
        return false;
      }
      const response = await orderCovenantDoSign({
        covenant_id: this.formStore.covenant_id,
        order_nos: this.$refs.table.selection.map(_ => {
          return _.order_no
        })
      })
      if (!response.success) {
        this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
        return;
      }
      this.showToast({h: this, icon: "el-icon-success", text: '操作成功', duration: 2000});
      await this.callbackSuccess()
      this.dialogStore = false;
    },
  }
}
</script>

<style lang="scss">
.workbench-component-orders-wait-container {
  height: 100%;
}
</style>
